import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import moment from 'moment';
import styles from './SentryTrackingButton.module.scss';
import Button from '@src/components/button/Button';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import { useToast } from '@src/hooks/useToast';
import SentryTrackingModal from './SentryTrackingModal';
import { ADD_SENTRY_TRACKING, GET_ENTITY_SENTRY_TRACKING } from './sentryGraphQL';


interface SentryTrackingButtonProps {
  entityId: string;
  entityType: 'user' | 'account' | 'school';
  entityName: string;
  onTrackingAdded?: () => void;
  buttonText?: string;
  buttonSize?: 'small' | 'normal' | 'extraSmall' | 'tiny';
  className?: string;
  isRowHovered?: boolean; // New prop to control visibility based on row hover
}

const SentryTrackingButton: React.FC<SentryTrackingButtonProps> = ({
  entityId,
  entityType,
  entityName,
  onTrackingAdded,
  buttonText = 'Track',
  buttonSize = 'small',
  className = '',
  isRowHovered = false, // Default to false
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const handleSuccess = () => {
    if (onTrackingAdded) {
      onTrackingAdded();
    }
  };

  return (
    <>
      <Button
        size={buttonSize}
        onClick={handleOpenModal}
        className={`${styles.sentryButton} ${isRowHovered ? styles.visible : ''} ${className}`}
        label={buttonText}
        leftIcon={
          <LordIcon
            src="https://cdn.lordicon.com/avcownel.json"
            trigger="hover"
            size={buttonSize === 'small' ? 18 : 24}
            colors={{ primary: '#274649', secondary: '#FFB073' }}
          />
        }
      />

      <SentryTrackingModal
        visible={isModalVisible}
        onClose={handleCloseModal}
        entityId={entityId}
        entityType={entityType}
        entityName={entityName}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default SentryTrackingButton;
